var _excluded = ["children", "color", "external", "variant", "loading"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import * as React from 'react';
import ButtonStyled from './styles/ButtonStyled';
import { CircleStyled, LoadingContainerStyled } from './styles/AnimationStyled';
var Button = function Button(_ref) {
  var children = _ref.children,
    color = _ref.color,
    external = _ref.external,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    props = _objectWithoutProperties(_ref, _excluded);
  var anchorProps = external !== null && external !== void 0 ? external : {};
  var loadingChildren = React.createElement(LoadingContainerStyled, null, React.createElement(CircleStyled, null), React.createElement(CircleStyled, null), React.createElement(CircleStyled, null));
  return React.createElement(ButtonStyled, _extends({}, props, anchorProps, {
    variant: variant,
    color: color === 'corporate' ? 'secondary' : 'primary',
    loading: loading
  }), loading ? loadingChildren : children);
};
export default Button;